import { connect } from 'react-redux';
import tagView from '../components/TagView';

import { openTagEditor, openGroupEditor, setView } from '../actions';

const mapStateToProps = state => ({
  tagGroups: state.tagGroups.filter((group) => {
    if (group.name.toLowerCase().includes(state.tagSearchText.toLowerCase())) return true;
    if (group.tags.some(tag =>
      tag.display.toLowerCase().includes(state.tagSearchText.toLowerCase()))) return true;
    return false;
  }),
  tagSearchText: state.tagSearchText,
  tagEditorOpen: state.tagEditor.open,
  groupEditorOpen: state.groupEditor.open,
});

const mapDispatchToProps = dispatch => (
  {
    openTagEditor: ({ tag, isNew }) => {
      dispatch(openTagEditor({ tag, isNew }));
    },
    openGroupEditor: ({ group, isNew }) => {
      dispatch(openGroupEditor({ group, isNew }));
    },
    setView: (view) => {
      dispatch(setView(view));
    },
  }
);

const TagView = connect(
  mapStateToProps,
  mapDispatchToProps,
)(tagView);

export default TagView;



// WEBPACK FOOTER //
// ./src/containers/TagView.js